export default __webpack_public_path__ + "search-autofill-demo-ios-ea4d58b889b933a47da0ad5499f6b201.mp4";